import { createFileRoute } from "@tanstack/react-router";
import { BygherreraadgivningPage, bygherreraadgivningHead } from "@/pages/BygherreraadgivningPage";

export const Route = createFileRoute("/en/client-consultancy")({
  head: () => bygherreraadgivningHead("en"),
  component: () => <BygherreraadgivningPage locale="en" />,
});
